import { IUser } from '../../../../utils/interfaces/user';
import React from 'react';
import { useLocalization } from 'src/utils/useLocalization';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';

const Footer: React.FC = () => {
    const { creditAppOtherInformation } = useLocalization();

    const { i18n } = useTranslation();

    const currentBrand =
        useSelector((state: IUser) => state.dealerDataInfo?.dealer.brand) ||
        'VW';
    const termsAndConditionsLink = `/terms-and-conditions?lang=${i18n.language}&brand=${currentBrand}`;

    return (
        <div className='o-fieldset__row'>
            <div className='o-layout'>
                <div className='o-layout__item u-1/1'>
                    {creditAppOtherInformation.FOOTER_FIRST}
                    <a
                        href={termsAndConditionsLink}
                        target='_blank'
                        rel='noreferrer'
                    >
                        <label className='u-base-link'>
                            {creditAppOtherInformation.FOOTER_LINK}
                        </label>
                    </a>
                    {creditAppOtherInformation.FOOTER_AND}
                    <a target='_blank' rel='noreferrer'>
                        <label className='u-base-link'>
                            {creditAppOtherInformation.FOOTER_PRIVACY_LINK}
                        </label>
                    </a>
                    {creditAppOtherInformation.FOOTER_LAST}
                </div>
            </div>
        </div>
    );
};

export default Footer;
